import { SEARCH_AROUND_DISTANCES } from '../../_constants/searchAroundDistances';

export const getSearchAroundOptions = () =>
  SEARCH_AROUND_DISTANCES.map(distance => ({
    value: `${distance} km`,
    label: `${distance} km`,
  }));
